<template>
<div>
  <Fieldset :legend="translate('education', 'ucfirst')"
    class="w-full px-5 pb-4 mt-5 bg-white rounded-lg shadow-md border border-color-iron">
    <Skeleton v-if="isLoading && graduations" height="1.5rem" class="mb-2"></Skeleton>
    <ul v-else-if="!isLoading && graduations.length > 0">
      <li>
        <div v-for="(graduation, index) in graduations" :key="index" class="mb-2.5">
          <h1 class="uppercase leading-5 font-semibold text-oxford-blue">
            {{ graduation.degree }}
          </h1>
          <h5 class="text-sm font-medium uppercase">{{ graduation.institution }}</h5>
          <div>
            <span class="text-sm font-medium">{{ dateFormated(graduation.start_date) }} - {{ dateFormated(graduation.end_date) }}</span>
          </div>
        </div>
      </li> 
    </ul>
    <div v-else> 
      <p class="font-medium">{{ translate('no education', 'ucfirst') }}</p>
    </div> 
  </Fieldset>        
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";


 const props = defineProps({
  educations: {
    type: Array,
    required: true,
    default: ()=> [],
  }
});

let graduations = ref([])
let isLoading = ref(false)


const dateFormated = ((date) => {
  return date.slice(0,10);
})

onUpdated(() => {
  isLoading.value = false
  if (props.educations.length > 0 ) graduations.value = props.educations
})

onMounted(() => {
  isLoading.value = true
});
</script>

<style scoped></style>